<div class="settings__query-container">
  <div class="settings__query">
    <settings-request-query-builder
      (search)="queryData($event, true)"></settings-request-query-builder>
  </div>
</div>

<div>
  <div class="settings__actions">
    <div
      *renderingPermissionDirective="[
        'BulkSettingReviewer',
        'BulkSettingRequester',
      ]"
      class="settings__modify-settings">
      <button
        class="lx-btn-small lx-btn-primary"
        type="button"
        (click)="openNewModificationRequestModal()">
        Modify Settings
      </button>
    </div>

    <div class="settings__refresh-container">
      <div class="settings__refresh">
        <button
          class="lx-btn-small lx-btn-text settings__refresh"
          (click)="onRefresh()">
          <i class="lx-icon lx-reset"></i>
          Refresh
        </button>
      </div>
    </div>
  </div>

  <div class="settings__data">
    <ag-grid-angular
      #grid
      class="ag-theme-alpine ag-grid-sticky-header"
      domLayout="autoHeight"
      style="width: 100%; height: 100%"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [enableCellTextSelection]="true"
      [ensureDomOrder]="true"
      [rowSelection]="'single'"
      [suppressRowHoverHighlight]="true"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="settings__pagination_container">
    <label>Show</label>
    <dcc-dropdown
      class="settings__pagination_container__row-count"
      [pageSizes]="pageSizes"
      [selectedSize]="pageSize"
      (changedPageSize)="onPageSizeSelected($event)"></dcc-dropdown>
    <label>Items</label>
    <paginator
      class="settings__pagination_container__pages"
      [currentPageNumber]="currentPage"
      [endOfSet]="endOfSet"
      [pageNumbers]="paginationDateMap.size"
      (selectedPage)="onPageSelection($event)"></paginator>
  </div>
</div>
